// extracted by mini-css-extract-plugin
export default {"wrapper":"PageWrapper_wrapper__+W1iG","contentWrapper":"PageWrapper_contentWrapper__1gCQo","bottom-gradient":"PageWrapper_bottom-gradient__XqYgs"};